import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const NanoMaterials = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
  <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Nano Materials"
    videos={[
      "https://www.youtube.com/embed/fg-D0XsPkCo",
      "https://www.youtube.com/embed/iOggL0Uurlw",
      "https://www.youtube.com/embed/3XpuoVVzT1A",
    ]}
    takeaways={[
      { text: "Sol gel method is Important." },
      { text: "Focus on Top-Down and Bottom-Up approach." },
      { text: "Learn the differences between Bulk materials and nano materials." },
    ]}
    questions={[
      "Discuss how the properties of nanomaterials differ from those of bulk materials? Explain a method for converting silicon precursor into nanosilica.",
      "Explain the synthesis of nano silica by sol-gel method.",
      "Give any two advantages and disadvantages of the bottom-up approach."
    ]}
    exampleVideos={[]}
  />
);
}

export default NanoMaterials;
